import { useEffect, useState } from "react"
import { TypedUseLazyQuery } from "@reduxjs/toolkit/query/react"

import { ApiTypes } from "types"

import { HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"
import { SENSOR_TYPE_COLORS } from "components/widgets/sensorWidgetColors"

const initialState = {
  total: 0,
  wls: 0,
  ths: 0,
}

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useLazyQuery: TypedUseLazyQuery<{ data: ApiTypes.Res.OrderSensorsWidget }, void, any>
  title?: string
  mainLabel?: string
}

export const WidgetOrderedSensors = ({
  useLazyQuery,
  title = "Ordered Sensors",
  mainLabel = "Sensors ordered",
}: Props) => {
  const [triggerGetOrderSensors, { isFetching }] = useLazyQuery()
  const [widgetData, setWidgetData] = useState(initialState)

  useEffect(() => {
    const fetchData = async () => {
      const res = await triggerGetOrderSensors()
      if (res?.data?.data) {
        const d = res.data.data
        setWidgetData({
          total: d.total ?? 0,
          wls: d.wls ?? 0,
          ths: d.ths ?? 0,
        })
      }
    }

    fetchData()
  }, [triggerGetOrderSensors])

  const items = [
    { label: "WLS", color: SENSOR_TYPE_COLORS.wls, value: widgetData.wls },
    { label: "THS", color: SENSOR_TYPE_COLORS.ths, value: widgetData.ths },
  ]

  return (
    <HalfDoughnutSummaryWidget
      title={title}
      mainLabel={mainLabel}
      items={items}
      mainValue={widgetData.total}
      chartOptions={{ cutout: "65%" }}
      showPercentage
      isFetching={isFetching}
    />
  )
}
